"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  ADD_NEW_CURRENCY: null,
  ARCHIVE_MULTI_CURRENCY: null,
  CONFIRM_GDPR_COMPLIANCE: null,
  CONFIRM_TIME_ZONE: null,
  DISABLE_SSO_CONFIRM: null,
  EDIT_HOME_CURRENCY: null,
  EDIT_MULTI_CURRENCY: null,
  EDIT_SSO: null,
  REQUIRE_SSO: null,
  REQUIRE_TWO_FACTOR_AUTH: null,
  SET_ACCOUNT_NAME: null,
  UNREQUIRE_SSO: null,
  UNREQUIRE_TWO_FACTOR_AUTH: null,
  EDIT_SSO_EXEMPT_USERS: null,
  ENABLE_JITA: null,
  DISABLE_JITA: null
});

exports.default = _default;
module.exports = exports.default;